import { atom } from "recoil";

export const activeMenuState = atom<string | null>({
    key: "productPage.activeMenu",
    default: null,
});
